import { useVerificationFieldContext } from '../../../../../context';

export function useImagesRulesController() {
  const { isDocument, isFace } = useVerificationFieldContext();

  return { isDocument, isFace };
}
